import type { Notification } from '../../lib/types';

export interface DetailRow { label: string; value: string }

const MAX_ROWS = 6;

/** Righe non vuote (massimo 6) e testo della descrizione, dai metadati della notifica. */
export function notificationDetailRows(metadata: Notification['metadata']): { rows: DetailRow[]; quote: string | null } {
  const raw = Array.isArray(metadata?.email_details) ? metadata!.email_details! : [];
  const rows = raw
    .filter((d) => d && typeof d.label === 'string' && d.value != null && String(d.value).trim() !== '')
    .map((d) => ({ label: d.label, value: String(d.value).trim() }))
    .slice(0, MAX_ROWS);
  const text = metadata?.email_quote?.text;
  const quote = typeof text === 'string' && text.trim() !== '' ? text.trim() : null;
  return { rows, quote };
}
